import { defaultValuesForProblematicKeys } from '../DefaultValuesForProblematicKeys';

export const sbeKatanaTheme = {
    customContent: {},
    fontsUsage: {},
    font: {
        main: 'Roboto, sans-serif',
        color: '#404247',
        colorAlternate: '#FFF',
        colorHighlight: '#404247',
        colorLight: '#6d7178',
        baseSize: '16px',
        smallerSize: '.8125rem',
        normalWeight: '400',
        bold: '700',
        lineHeight: '1.5'
    },
    lotaltyPoints: {
        color: '',
        fontWeight: ''
    },
    productIcons: {
        colorHighlight: ''
    },
    grid: {
        head: {
            background: '',
            color: '',
            fontWeight: '',
            fontSize: '',
            border: "#CACCD1",
            textTransform: "none"
        },
        row: {
            background: '',
            'background.hover': '',
            border: '',
            color: '',
            fontWeight: '',
            fontSize: "1rem"
        },
        shadow: {
            row: "linear-gradient(to bottom,rgba(0,0,0,.1) 0,rgba(0,0,0,0) 0rem)"
        }
    },
    heroImage: {
        hotelDetails: {
            background: "#ffffffbf",
            color: "#404247",
            fontWeight: "400",
            maxWidth: "100%",
            link: {
                color: "#404247",
                fontWeight: "400"
            }
        },
        background: "",
        height: {
            desktop: "425px"
        }
    },
    landingPage: {
        background: {
            image: "",
            repeat: "no-repeat",
            position: "center center",
            attachment: "fixed",
            size: "cover"
        }
    },
    h1: {
        color: "#121315",
        fontSize: "2.25rem",
        fontWeight: "700",
        fontFamily: "'Roboto Condensed', sans-serif",
        textTransform: "none",
        lineHeight: "1.25"
    },
    h2: {
        color: "#121315",
        fontSize: "1.938rem",
        fontWeight: "700",
        fontFamily: "'Roboto Condensed', sans-serif",
        textTransform: "none",
        lineHeight: "1.15"
    },
    h3: {
        color: "#121315",
        fontSize: "1.563rem",
        fontWeight: "700",
        fontFamily: "'Roboto Condensed', sans-serif",
        textTransform: "none",
        lineHeight: "1.5"
    },
    h4: {
        color: "#121315",
        fontSize: "1.25rem",
        fontWeight: "700",
        fontFamily: "'Roboto', sans-serif",
        textTransform: "none",
        lineHeight: "1.25"
    },
    h5: {
        color: "#121315",
        fontSize: "1rem",
        fontWeight: "700",
        fontFamily: "'Roboto', sans-serif",
        textTransform: "none",
        lineHeight: "1.5"
    },
    link: {
        color: {
            normal: "#309ab5",
            hover: "#2E3034",
            active: "#000",
            default: "#404247",
            focus: "#2E3034"
        },
        underline: {
            default: {
                width: "1px",
                style: "solid",
                color: "#309AB5"
            },
            hover: {
                width: "1px",
                style: "solid",
                color: "#309ab5"
            },
            focus: {
                width: "2px",
                style: "solid",
                color: "#309ab5"
            },
            active: {
                width: "1px",
                style: "solid",
                color: "#309ab5"
            }
        },
        fontWeight: "400",
        highlight: {
            color: {
                normal: "#007b94",
                hover: "#006074",
                active: "#00495a"
            },
            fontWeight: "400",
            textDecoration: defaultValuesForProblematicKeys.linkHighlightTextDecoration,
            'textDecoration.hover': defaultValuesForProblematicKeys.linkHighlightTextDecorationHover,
            'textDecoration.active': defaultValuesForProblematicKeys.linkHighlightTextDecorationActive,
        }
    },
    urgencyTrigger: {
        inline: {
            color: ""
        },
        floating: {
            background: "#007b94",
            color: "#E1E2E5"
        }
    },
    border: {
        radius: "0.75rem",
        color: {
            style1: "#E1E2E5",
            style2: "#CACCD1"
        }
    },
    background: {
        body: "#F6F6F7",
        style1: "#FFFFFF",
        style2: "#F6F6F7",
        style3: "#007b94"
    },
    box: {
        shadow: defaultValuesForProblematicKeys.boxShadow,
        'shadow.stickyElements': defaultValuesForProblematicKeys.boxShadowStickyElements
    },
    modal: {
        overlay: {
            background: "#000000bf",
            close: "#FFF"
        },
        borderRadius: "0.75rem"
    },
    gallery: {
        overlay: {
            background: "#000"
        },
        text: {
            background: "#000000bf",
            color: "#FFF"
        }
    },
    spinner: {
        color1: "#12131533",
        color2: "#121315"
    },
    page: {
        favicon: ""
    },
    flexpay: {
        logo: {
            url: "url()"
        }
    },
    googlePay: {
        logo: {
            url: "url()"
        }
    },
    applePay: {
        logo: {
            url: "url()"
        }
    },
    nexi: {
        logo: {
            url: "url()"
        }
    },
    header: {
        alwaysShowHotelName: false,
        userBar: {
            background: "#FFF",
            font: "'Roboto', sans-serif",
            fontSize: "1rem",
            fontWeight: "400",
            textTransform: "uppercase",
            color: {
                normal: "#333",
                hover: "#6D7178"
            },
            textDecoration: {
                normal: "none",
                hover: "none"
            },
            iconColor: {
                normal: "#333",
                hover: "#6D7178"
            }
        },
        logo: {
            url: "url()",
            size: "contain",
            position: "center",
            width: "77px",
            height: "39px"
        },
        hamburgerMenu: {
            background: {
                normal: "#fff"
            },
            color: {
                normal: "#333"
            },
            width: "60px",
            iconSize: "40px",
            link: {
                textTransform: "uppercase"
            }
        },
        criteria: {
            overlay: "#ffffffbf"
        }
    },
    input: {
        size: "16px",
        color: "#404247",
        'color.disabled': defaultValuesForProblematicKeys.inputColorDisabled,
        style: "normal",
        weight: "700",
        font: "'Roboto', sans-serif",
        height: "3.75em",
        borderRadius: "12px",
        padding: "0 .75rem",
        background: {
            normal: "#f6f6f7",
            hover: "#FFFFFF",
            focus: "#FFFFFF",
            disabled: "#f6f6f7"
        },
        border: {
            normal: "1px solid #6d7178",
            focus: "3px solid #309ab5",
            hover: "1px solid #6d7178"
        },
        label: {
            font: '',
            size: '',
            weight: '',
            color: '',
            height: "1.5em"
        },
        checkboxAndRadio: {
            disabledText: "#A1A1A1"
        },
        required: "#d13630"
    },
    button: {
        shadow: {
            focus: "0 0 0 2px #fff, 0 0 0 5px #309ab5"
        },
        medium: {
            lineHeight: "1.19rem",
            padding: ".969rem 1.5rem"
        },
        small: {
            lineHeight: "1.19rem",
            padding: ".531rem 1.5rem"
        },
        primary: {
            font: "'Roboto Condensed', sans-serif",
            fontSize: "20px",
            style: "normal",
            weight: "700",
            textTransform: "uppercase",
            borderRadius: "0.75rem",
            background: {
                normal: "#404247",
                hover: "#2e3034",
                active: "#121315"
            },
            border: {
                normal: "3px solid #121315",
                hover: "3px solid #121315",
                active: "3px solid #121315"
            },
            color: {
                normal: "#FFF",
                hover: "#ADB1B8",
                active: "#ADB1B8"
            },
            spinner: {
                color1: "#ffffff33",
                color2: "#FFF"
            }
        },
        secondary: {
            font: "'Roboto Condensed', sans-serif",
            fontSize: "20px",
            style: "normal",
            weight: "700",
            textTransform: "uppercase",
            borderRadius: "0.75rem",
            background: {
                normal: "#FFFFFF",
                hover: "#E9EAEB"
            },
            border: {
                normal: "3px solid #121315",
                hover: "3px solid #202224"
            },
            color: {
                normal: "#121315",
                hover: "#121315"
            },
            spinner: {
                color1: "#12131533",
                color2: "#121315"
            }
        },
        link: {
            font: "'Roboto Condensed', sans-serif",
            fontSize: "1rem",
            style: "normal",
            weight: "700",
            textTransform: "uppercase",
            color: {
                normal: "#007b94",
                hover: "#006074",
                active: "#00495a",
                disabled: "#adb1b8"
            },
            textDecoration: {
                normal: "none",
                hover: "none",
                active: "none"
            },
            icon: {
                color: {
                    normal: "#007b94",
                    hover: "#006074",
                    active: "#00495a",
                    disabled: "#adb1b8"
                },
                size: "1rem"
            }
        },
        disabled: {
            background: "#adb1b8",
            border: "3px solid #adb1b8",
            color: "#fff"
        }
    },
    message: {
        success: {
            color: "#007447",
            colorLight: "#DCFFE6",
            icon: "#FFF"
        },
        info: {
            color: "#006E87",
            colorLight: "#E9F9FF",
            icon: "#FFF"
        },
        warning: {
            color: "#9A5200",
            colorLight: "#FFF7D4",
            icon: "#FFF"
        },
        error: {
            color: "#C12620",
            colorLight: "#FFF4F1",
            icon: "#FFF"
        },
        roomCard: {
            color: "#000",
            background: "#ff8d2e99"
        },
        memberRate: {
            color: "#674571",
            fontWeight: "700",
            textTransform: "uppercase"
        }
    },
    calendar: {
        date: {
            noCheckIn: {
                background: "linear-gradient(to right bottom, #939497 50%, #FFF 50%)",
                color: "#2A2C31"
            },
            noCheckOut: {
                background: "linear-gradient(to left top, #939497 50%, #FFF 50%)",
                color: "#2A2C31"
            },
            unavailableFutureDate: {
                background: "#FFFFFF",
                textColor: "#6D7178",
                lineColor: "#939497"
            },
            selected: {
                background: "#007B94",
                color: "#FFF",
                spinner: {
                    color1: "#ffffff33",
                    color2: "#FFF"
                }
            },
            available: {
                background: "#FFFFFF",
                color: "#555"
            },
            unavailable: {
                background: "#EEE",
                color: "#A1A1A1"
            },
            textSize: "1rem"
        },
        dot: {
            color: "",
            border: "#FFFFFF"
        },
        tooltip: {
            background: "",
            border: "",
            color: ""
        },
        inlinePrice: {
            textSize: ".7rem"
        }
    },
    imageHeight: {
        hotel: "230px"
    },
    palette: {
        primary: {
            colors: [
                {
                    color: "#E50000",
                    label: "first"
                },
                {
                    color: "#23826F",
                    label: "second"
                },
                {
                    color: "#006479",
                    label: "third"
                },
                {
                    color: "#FF8D2E",
                    label: "fourth"
                },
                {
                    color: "#FFC694",
                    label: "fifth"
                },
                {
                    color: "#3399CC",
                    label: "sixth"
                },
                {
                    color: "#79CAF2",
                    label: "seventh"
                },
                {
                    color: "#5FE9EA",
                    label: "eighth"
                },
                {
                    color: "#099C9D",
                    label: "ninth"
                },
                {
                    color: "#B0EA3B",
                    label: "tenth"
                },
                {
                    color: "#729135",
                    label: "eleventh"
                },
                {
                    color: "#121315",
                    label: "twelfth"
                }
            ],
            selected: 0
        },
        background: {
            body: "#F6F6F7",
            style1: "#FFFFFF",
            style2: "#F6F6F7",
            style3: "#006479"
        },
        messages: {
            colors: [
                {
                    color: "#AC0000",
                    label: "Error"
                },
                {
                    color: "#CD8511",
                    label: "Warning"
                },
                {
                    color: "#75A01F",
                    label: "Success"
                },
                {
                    color: "#4A5767",
                    label: "Informational"
                }
            ],
            selected: 0
        },
        message: {
            success: {
                color: "#008247",
                icon: "#FFF"
            },
            info: {
                color: "#007b94",
                icon: "#FFF"
            },
            warning: {
                color: "#a75f00",
                icon: "#FFF"
            },
            error: {
                color: "#d13630",
                icon: "#FFF"
            }
        },
        border: {
            radius: "10px",
            color: {
                style1: "#E1E2E5",
                style2: "#ADB1B8"
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/constants/themes/sbeKatanaTheme.js